import { render } from "./BaseModuleModal.vue?vue&type=template&id=2c10d764&scoped=true"
import script from "./BaseModuleModal.vue?vue&type=script&lang=js"
export * from "./BaseModuleModal.vue?vue&type=script&lang=js"

import "./BaseModuleModal.vue?vue&type=style&index=0&id=2c10d764&scoped=true&lang=css"
import "./BaseModuleModal.vue?vue&type=style&index=1&id=2c10d764&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c10d764"]])

export default __exports__